import { render, staticRenderFns } from "./Mercancia.vue?vue&type=template&id=06af1785&"
import script from "./Mercancia.vue?vue&type=script&lang=js&"
export * from "./Mercancia.vue?vue&type=script&lang=js&"
import style0 from "./Mercancia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports